const apis = {
    GET_SEARCH_COSTUMER: "/admin/clientes/buscar/"
}

export default  apis;